module.exports = __webpack_public_path__ + "media/images/custom-photoshoot-ff4538cd1f2f716be2dc5e1437d6b5f4.png";